module.exports = __webpack_public_path__ + "static/gallery-11-ba12477eaec948c32c942693a96914fe.jpg";